import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { loadRuntimeConfig } from './environments/environment';

import { AppModule } from './app/app.module';

// Load runtime configuration before bootstrapping Angular
loadRuntimeConfig().then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}).catch(err => {
  console.error('Failed to load runtime configuration:', err);
  // Bootstrap anyway with default configuration
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(bootstrapErr => console.error(bootstrapErr));
});
